module.exports = __webpack_public_path__ + "product-pure-powder-capsule-02.jpg?44558bd686ab63465ca98a1509038cc1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-02.jpg
// module id = 84
// module chunks = 0